<template>
  <div :class="[`view-491-1`, className || ``]">
    <div class="rectangle-84"></div>
    <p class="text-47-2 calibri-bold-white-35px">
      <span class="span-14 calibri-bold-white-35px">{{ spanText1 }}</span
      ><span class="span1-12 calibri-bold-white-35px">{{ spanText2 }}</span
      ><span class="span-14 calibri-bold-white-35px">&nbsp;&nbsp;Изучение 1С. Практическое руководство</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "View792",
  props: ["spanText1", "spanText2", "className"],
};
</script>

<style>
.view-491-1 {
  height: 115px;
  margin-top: 143.4px;
  position: relative;
  width: 490px;
}

.rectangle-84 {
  background-color: var(--black-2);
  border-radius: 20px;
  height: 115px;
  left: 0;
  position: absolute;
  top: 0;
  width: 488px;
}

.text-47-2 {
  left: 14px;
  line-height: normal;
  position: absolute;
  top: 21px;
  width: 423px;
}

.span-14 {
  letter-spacing: 0;
}

.span1-12 {
  letter-spacing: 1.23px;
}

.view-491-1.view-493 {
  height: 115px;
  left: 0;
  position: absolute;
  top: 143px;
  width: 490px;
}
</style>
